import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Heading from '../../components/Heading';
import Tabs from '../../components/Tabs';
import WithNavigation from '../../layouts/WithNavigation';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectLoader } from '../../store/selectors/loader';
import Loader from '../../components/Loader';
import EmailTemplatesTable from '../../components/EmailTemplatesTable';


class EmailTemplates extends Component {
  
  render() {
    const { loader } = this.props;
    const {emailTemplates}=this.props.emailTemplates;

    return (
      <>
      {loader ?
           <Loader center={true}/>
           :null}
      <WithNavigation
        title="Email Templates"
        top={(
          <Heading
            headline="Email Templates"
          />
        )}
        bottom={
          (
          <Tabs
            items={[
              {
                label: 'Email Templates',
                length: emailTemplates.length,
                content: (
                  <EmailTemplatesTable     
                  />
                )
              }
            ]}
          />
        )}
      />
        </>
    );
  }
}

const mapStateToProps = state => ({
  emailTemplates:state.emailTemplates,
  user:selectAuthenticatedUser(state),
  loader: selectLoader(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplates);
